// Local config + utilities matching backend Spark logic.
import { Coins, Users, Sparkles, Crown, Award, Sparkle } from "lucide-react";

export const LEVELS = [
  {
    id: "fundador",
    name: "Fundador",
    icon: Award,
    accent: "#3D6FB5",
    desc: "Pionero. Estuviste cuando todo empezó.",
  },
  {
    id: "embajador",
    name: "Embajador",
    icon: Sparkle,
    accent: "#E07A5F",
    desc: "Construyes red. Tu invitación abre puertas.",
  },
  {
    id: "maestro",
    name: "Maestro",
    icon: Crown,
    accent: "#C29B5E",
    desc: "Creador de alto valor. Voz que mueve la plataforma.",
  },
];

export const REDEEM_ITEMS = [
  { id: "promote_content", icon: Sparkles, cost: 500,  label: "Promoción de contenido",     desc: "+1,000 vistas garantizadas en Modo Horizonte de tu nicho.", category: "promotion" },
  { id: "profile_banner",  icon: Award,    cost: 1000, label: "Banner del perfil",          desc: "Diseño personalizado animado para tu portada.",            category: "profile" },
  { id: "profile_frame",   icon: Sparkle,  cost: 800,  label: "Marco de avatar animado",    desc: "Anillo animado exclusivo para tu foto de perfil.",         category: "profile" },
  { id: "marketplace_5",   icon: Coins,    cost: 500,  label: "$5 USD crédito Marketplace", desc: "Canjeable como saldo en cualquier compra.",                category: "marketplace" },
  { id: "marketplace_25",  icon: Coins,    cost: 2200, label: "$25 USD crédito Marketplace",desc: "Bonificación 12% sobre el canje individual.",              category: "marketplace" },
  { id: "ai_credits_pack", icon: Sparkles, cost: 1500, label: "200 créditos de IA",         desc: "Para redactar, traducir, editar reels sin caps.",          category: "promotion" },
];

export const ACTION_LABELS = {
  post_created:        "Publicación creada",
  like_received:       "Reacciones recibidas",
  comment_received:    "Comentario recibido",
  music_upload:        "Música subida",
  music_play:          "Reproducción",
  tip_received:        "Propina recibida",
  referral_activated:  "Referido activado",
  daily_login:         "Conexión diaria",
  challenge_easy:      "Reto fácil",
  challenge_medium:    "Reto comunitario",
  challenge_hard:      "Reto épico",
  promote_content:     "Promoción canjeada",
  profile_banner:      "Banner desbloqueado",
  profile_frame:       "Marco desbloqueado",
  marketplace_5:       "Crédito Marketplace $5",
  marketplace_25:      "Crédito Marketplace $25",
  ai_credits_pack:     "Pack créditos IA",
};

export const CATEGORY_LABELS = {
  promotion:   "Promoción",
  profile:     "Personalización del perfil",
  marketplace: "Crédito Marketplace",
};
